import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { ContentLanguage } from 'types/general';
import { TranslatedText } from './ai-translate.types';

interface TranslateText {
  context: 'admin' | 'melp';
  data: {
    text: string;
    inputLanguage: Uppercase<ContentLanguage>;
    outputLanguage: Uppercase<ContentLanguage>;
  };
}

export const loaders = {
  translateText: ({ context, data }: TranslateText) => {
    return api<TranslatedText>({
      url: Endpoints.clientAdmin.translations.translate,
      context,
      data,
      method: 'post',
    });
  },
};
